import { useState, createContext } from "react";

export const branchSwitchContext = createContext();

const BranchSwitchProvider = (props) => {
  const [branchSwitch, setBranchSwitch] = useState("");

  return (
    <branchSwitchContext.Provider value={{ branchSwitch, setBranchSwitch }}>
      {props.children}
    </branchSwitchContext.Provider>
  );
};

export default BranchSwitchProvider;
